module.exports = __webpack_public_path__ + "static/img/slider-2.3821df0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-2.jpg
// module id = +W++
// module chunks = 1